export const SERVICE_REQUEST_TABS = {
    OPEN_POSTINGS: 'Open Postings',
    MY_OPEN: 'My Open',
    MY_RESPONSES: 'My Responses',
    AWARDED: 'Awarded',
    MY_AWARDED: 'My Awarded',
    EXPIRED_UNASSIGNED: 'Expired Unassigned',
    ALL: 'All'
} as const

export type ServiceRequestTab = typeof SERVICE_REQUEST_TABS[keyof typeof SERVICE_REQUEST_TABS]

export const PROVIDER_SERVICE_REQUEST_TABS: ServiceRequestTab[] = [
    SERVICE_REQUEST_TABS.OPEN_POSTINGS,
    SERVICE_REQUEST_TABS.MY_RESPONSES,
    SERVICE_REQUEST_TABS.AWARDED
]

export const WAIVER_SERVICE_REQUEST_TABS: ServiceRequestTab[] = [
    SERVICE_REQUEST_TABS.MY_OPEN,
    SERVICE_REQUEST_TABS.MY_RESPONSES,
    SERVICE_REQUEST_TABS.MY_AWARDED,
    SERVICE_REQUEST_TABS.EXPIRED_UNASSIGNED,
    SERVICE_REQUEST_TABS.ALL
]

export const MARKET_ADMIN_SERVICE_REQUEST_TABS: ServiceRequestTab[] = [
    SERVICE_REQUEST_TABS.OPEN_POSTINGS,
    SERVICE_REQUEST_TABS.EXPIRED_UNASSIGNED,
    SERVICE_REQUEST_TABS.ALL
]

export const DEFAULT_SERVICE_REQUEST_TABS: ServiceRequestTab[] = [
    SERVICE_REQUEST_TABS.OPEN_POSTINGS,
    SERVICE_REQUEST_TABS.AWARDED,
    SERVICE_REQUEST_TABS.ALL
]

export const EXPIRED_UNASSIGNED_INLINE_BREAKPOINT = 1200

export const RESEND_SERVICE_POSTINGS_BUTTON_TEXT = 'Resend Service Postings'

export const getResendServicePostingsAriaLabel = (serviceIdentifier: string | number): string =>
    `${RESEND_SERVICE_POSTINGS_BUTTON_TEXT} for authorization ${serviceIdentifier}`
